import { useAppDispatch, useAppSelector } from "@app/store";
import { useUserId } from "@hooks/use-user-id";
import { useCallback, useEffect } from "react";
import { getLeadBalances, getLeadPartners, getRefOrders } from "./slice";
import { PaginationParameters } from "@request";

export const useLead = () => {
  const userId = useUserId();
  const state = useAppSelector((state) => state.leadSlice);

  const dispatch = useAppDispatch();

  const getLeadBalancesHandler = useCallback(
    () => dispatch(getLeadBalances(userId)),
    [dispatch, userId]
  );

  useEffect(() => {
    getLeadBalancesHandler();

    const interval = setInterval(() => {
      getLeadBalancesHandler();
    }, 60000);

    return () => {
      clearInterval(interval);
    };
  }, [getLeadBalancesHandler]);

  const getLeadPartnersHandler = useCallback(
    () => dispatch(getLeadPartners(userId)),
    [dispatch, userId]
  );

  const getLeadOrdersHandler = useCallback(
    (data: PaginationParameters) => dispatch(getRefOrders({ userId, data })),
    [dispatch, userId]
  );

  return {
    state,
    getBalances: getLeadBalancesHandler,
    getLeadPartners: getLeadPartnersHandler,
    getLeadOrders: getLeadOrdersHandler,
  };
};
